import { Project } from 'api/project';
import {
  NumberFieldFilter,
  NumberFilterOperationType,
} from '../filters/number';
import { FilterFunction } from '.';

export const numberOfPeriods = (filter: NumberFieldFilter): FilterFunction => {
  switch (filter.type) {
    case NumberFilterOperationType.IsEmpty:
      return (record) =>
        (record?.currentPeriodData as Project['currentPeriodData'])
          ?.numberOfPeriods == null;
    case NumberFilterOperationType.IsNotEmpty:
      return (record) =>
        (record?.currentPeriodData as Project['currentPeriodData'])
          ?.numberOfPeriods != null;
    case NumberFilterOperationType.Is:
      return (record) =>
        (record?.currentPeriodData as Project['currentPeriodData'])
          ?.numberOfPeriods === filter.value;
    case NumberFilterOperationType.IsGreaterThan:
      return (record) => {
        const val = (record?.currentPeriodData as Project['currentPeriodData'])
          ?.numberOfPeriods;

        return val == null ? false : val > filter.value!;
      };
    case NumberFilterOperationType.IsLessThan:
      return (record) => {
        const val = (record?.currentPeriodData as Project['currentPeriodData'])
          ?.numberOfPeriods;

        return val == null ? false : val < filter.value!;
      };
    default:
      return () => true;
  }
};
